import { render, staticRenderFns } from "./BulkUploadCard.vue?vue&type=template&id=181d091c&scoped=true"
import script from "./BulkUploadCard.vue?vue&type=script&lang=js"
export * from "./BulkUploadCard.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadCard.vue?vue&type=style&index=0&id=181d091c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d091c",
  null
  
)

export default component.exports